import { api } from "../../gateways/unilabApi";

export async function getDrawingsList(payload) {
  return await api.get(`drawing/listFiltered?isSaldobrasata=` + payload);
}
export async function getDrawingsExportList() {
  return await api.get(`drawing/listfullExport`);
}
export async function getExportModel() {
  return await api.get(`drawing/exportModel`);
}
export async function postUpdateAddAllExport(payload) {
  return await api.post(`drawing/updateAddAllExport`, payload);
}
export async function postUploadImage(payload) {
  var formData = new FormData();
  formData.append("image", payload);
  return await api.post(`drawing/uploadImage`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
export async function getImageMod(payload) {
  return await api.get(`drawing/getImmagine/${payload}`);
}
export async function getDimensions(payload) {
  return await api.get(`drawing/getDimensioni/${payload}`);
}
export async function saveDimensions(payload) {
  return await api.post(`drawing/saveDimensions`, payload);
}
